import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { InternalBankingData } from "../../financial.types";
import { requestInternalBank } from "./useInternalBank.request";

const useInternalBank = (
  options?: QueryOptions<InternalBankingData, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["internal-bank"],
    queryFn: requestInternalBank,
    ...options
  });

  return { internalBank: data, ...rest };
};

export default useInternalBank;
